export default function Footer() {
  const practiceAreas = [
    { name: 'Car Accidents', link: '/car-accidents' },
    { name: 'Workplace Injuries', link: '/workplace-injuries' },
    { name: 'Medical Malpractice', link: '/medical-malpractice' },
    { name: 'Slip and Fall', link: '/slip-and-fall' },
    { name: 'Wrongful Death', link: '/wrongful-death' },
    { name: 'Product Liability', link: '/product-liability' },
    { name: 'Immigration Law', link: '/immigration' }
  ];

  return (
    <footer className="bg-gray-900 text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Firm info */}
          <div className="md:col-span-5">
            <div className="leading-none mb-6">
              <p className="text-[10px] tracking-[0.25em] uppercase text-gray-500 mb-0.5" style={{ fontFamily: "'Inter', sans-serif" }}>
                Law Office of
              </p>
              <h3 className="text-2xl font-bold tracking-widest uppercase text-white leading-none" style={{ fontFamily: "'Playfair Display', serif" }}>
                Hong-Min Jun
              </h3>
              <div className="flex justify-end">
                <p className="text-[9px] tracking-[0.2em] uppercase text-gray-500 mt-2" style={{ fontFamily: "'Inter', sans-serif" }}>
                  Attorney at Law
                </p>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Dedicated legal representation for foreign-born individuals and small business owners in Indiana. We fight for your rights with expertise and compassion.
            </p>
            <div className="space-y-3">
              <p className="text-sm text-gray-400">
                <span className="text-xs tracking-wider uppercase text-gray-500 block mb-1">Address</span>
                10150 Lantern Rd, Suite #175<br />
                Fishers, IN 46037
              </p>
              <p className="text-sm text-gray-400">
                <span className="text-xs tracking-wider uppercase text-gray-500 block mb-1">Phone</span>
                (317) 701-2768
              </p>
              <p className="text-sm text-gray-400">
                <span className="text-xs tracking-wider uppercase text-gray-500 block mb-1">Email</span>
                askus@junlawfirm.com
              </p>
            </div>
          </div>

          {/* Practice areas */}
          <div className="md:col-span-4">
            <h4 className="text-xs tracking-wider uppercase text-gray-500 mb-6">Practice Areas</h4>
            <ul className="space-y-3">
              {practiceAreas.map((area, index) => (
                <li key={index}>
                  <a href={area.link} className="text-sm text-gray-400 hover:text-white transition-colors" style={{ fontFamily: "'Inter', sans-serif" }}>
                    {area.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Hours */}
          <div className="md:col-span-3">
            <h4 className="text-xs tracking-wider uppercase text-gray-500 mb-6">Office Hours</h4>
            <div className="space-y-3 text-sm text-gray-400" style={{ fontFamily: "'Inter', sans-serif" }}>
              <p>Monday - Friday<br />9:00 AM - 6:00 PM</p>
              <p>Saturday<br />10:00 AM - 2:00 PM</p>
              <p>Sunday<br />Closed</p>
              <p className="text-white font-medium pt-3">24/7 Emergency Line Available</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500" style={{ fontFamily: "'Inter', sans-serif" }}>
              © {new Date().getFullYear()} Law Office of Hong-min Jun, P.C. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
          <p className="text-xs text-gray-600 mt-6 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            Disclaimer: The information on this website is for general information purposes only. Nothing on this site should be taken as legal advice for any individual case or situation. This information is not intended to create, and receipt or viewing does not constitute, an attorney-client relationship.
          </p>
        </div>
      </div>
    </footer>
  );
}
